module.exports = __webpack_public_path__ + "static/media/empty-dashboard.fa1513b5.svg";